import { useMutation } from '@tanstack/react-query';
import { deletePractice } from '../queries/post';

export function useDeletePractice() {
  const { mutate, data, isPending, isSuccess } = useMutation({
    mutationKey: ['deletePractice'], 
    mutationFn: (id: string) => deletePractice(id),
    retry: false
  });

  return { mutate, data, isPending, isSuccess };
}
